<template>
  <div class="ih-page-payment ih-page">
    <form @submit.prevent="submit()">
      <h3 class="ih-margin-bottom-15 text-center">選擇支付方式</h3>
      <div class="ih-row-5 row">
        <div
          class="col-6"
          v-for="payment_method in $payment_methods"
          :key="payment_method.payment_method_id"
        >
          <div class="ih-theme-radio form-group">
            <div
              class="ih-theme-button-yellow form-check"
              :class="{'ih-active': payment_method.payment_method_id === form_payment_method_id}"
            >
              <input
                type="radio"
                class="form-check-input"
                name="payment_method"
                :id="'payment_method' + payment_method.payment_method_id"
                :value="payment_method.payment_method_id"
                v-model="form_payment_method_id"
              />
              <i class="fa fa-music" aria-hidden="true"></i>
              <label
                class="form-check-label"
                :for="'payment_method' + payment_method.payment_method_id"
              >{{ payment_method.display_name }}</label>
            </div>
          </div>
        </div>
      </div>

      <br />

      <div class="alert alert-danger text-center" v-if="formError">請選擇支付方式</div>

      <div class="form-group">
        <div class="ih-row-5 row">
          <div class="col-6">
            <button type="button" class="ih-theme-button-white" @click="$router.go(-1)">回上一頁</button>
          </div>
          <div class="col-6">
            <button type="submit" class="ih-theme-button-yellow">確定</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>



<script>
export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      formError: false,

      form_payment_method_id: 0
    };
  },

  computed: {
    $payment_methods() {
      return this.$store.state.payment_methods;
    }
  },
  watch: {},
  methods: {
    submit() {
      if (!this.form_payment_method_id) {
        this.formError = true;

        return;
      }

      this.$store.commit(
        "set_form_payment_method_id",
        this.form_payment_method_id
      );

      $.ajax({
        method: "POST",
        url: `${this.apiBase}/api/v1/transactions/reserve`,
        data: this.$store.state.form
      })
        .done(res => {
          // 機器被佔用... 等等錯誤
          if (res.status !== 0) {
            this.$router.push({
              path: "/result",
              query: { message: "付款流程取消<br>請重新操作" }
            });

            return;
          }

          // 行動支付
          if (res.redirect_path) {
            window.location = res.redirect_path;

            return;
          }

          // 卡片
          const payment_method = this.$store.state.payment_methods.find(el => {
            return (
              el.payment_method_id === this.$store.state.form.payment_method_id
            );
          });

          if (payment_method.type === "card") {
            this.$router.push({
              path: "/result",
              query: { message: "請將卡片靠近刷卡機<br>並依刷卡機畫面指示操作" }
            });
          }
        })
        .fail(err => {
          this.$router.push({
            path: "/result",
            query: { message: err.message }
          });
        })
        .always(res => {});
    }
  },

  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/pages/Payment";
</style>
